<template>
    <div id="drop-box" :class="!hideDrop && dragOver ? 'ramka-2-wr' : 'ramka-1'"
        @dragover="dragOver = true"
        @dragend="dragOver = false"
        @dragleave="dragOver = false"
        @drop.prevent="drop($event)">
        <div class="ramka-2"><slot ></slot></div>
    </div>

</template>

<script>

export default {
    props: {
        hideDrop: {
            type: Boolean,
            default: false
        },
        multiDrop: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            dragOver: false
        };
    },
    mounted()
    {
        window.addEventListener("dragover",function(e){
            e.preventDefault();
        },false);
    },
    methods: {
        drop(e) {
            this. dragOver = false;
            //eeee
            let files = Array.from(e.dataTransfer.files)
            if (e && files && !this.hideDrop) {
                files.forEach((file, index) => {
                       this.$emit("fileDropped", file, e.path, index);
                })

            }
        },
    }
}
</script>

<style lang="scss">
.ramka-1 {
    padding: 2px;
}
.ramka-2-wr {
    box-sizing: border-box;
    padding: 2px;
    position: relative;
    overflow: hidden;
}
.ramka-2-wr .ramka-2 {
    height: 100%;
    display: flex;
}
.ramka-2-wr::before {
    content: '';
    position: absolute;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
            #FFF 0%,
            #FFF 7.5px,
            #BFE2FF 7.5px,
            #BFE2FF 15px,
            #FFF 15px,
            #FFF 22.5px,
            #BFE2FF 22.5px,
            #BFE2FF 30px);
    transform: translateX(-20%) translateY(-20%) rotate(-45deg);
    animation: anim-ramka-2 20s linear infinite;
}
.ramka-2-wr .ramka-2 {
    position: relative;
    background-color: #FFF;
    flex-direction: column;
}
.ramka-2-wr,
.ramka-2-wr .ramka-2 {
    box-shadow: 0 0 2px #BFE2FF, 0 0 5px rgba(0, 0, 0, 0.2), inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
}
@keyframes anim-ramka-2 {
    from {
        background-position: 0;
    }

    to {
        background-position: 0 450px;
    }
}
</style>
